package uz.ferro.erp.ui.table

import web.cssom.Length

data class HeaderItem(
    val title: String = "",
    val width: Length? = null
)
